var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.callFrom && _vm.callFrom.name == 'client-contract-template'),
      expression: "callFrom && callFrom.name=='client-contract-template'"
    }],
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("CFT Divisor: " + _vm._s(_vm.voluMetricWtDivisor))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Preffered UOM for Dimensions: " + _vm._s(_vm.uom))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Agreed Weight per CFT (kg)")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.agreedweight),
      expression: "agreedweight"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Agreed Weight')
    },
    attrs: {
      "id": "agreedweight",
      "min": _vm.MinCft,
      "type": "number",
      "name": "Agreed Weight",
      "placeholder": "Enter Agreed Weight"
    },
    domProps: {
      "value": (_vm.agreedweight)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.agreedweight = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Agreed Weight')),
      expression: "errors.has('Agreed Weight')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('Agreed Weight')))])], 1), _vm._v(" "), (_vm.ratebasis == 1) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('label', [_vm._v("Minimum Chargeable Weight (kg)")]), _c('span', {
    staticClass: "text-danger"
  }), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.minChargeWeight),
      expression: "minChargeWeight"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "id": "minChargeWeight",
      "type": "number",
      "name": "Minimum Weight",
      "placeholder": "Enter Minimum Weight"
    },
    domProps: {
      "value": (_vm.minChargeWeight)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.minChargeWeight = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.minweightflag),
      expression: "minweightflag"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Minimum Chargeable Weight Field is required")])], 1) : _vm._e(), _vm._v(" "), (_vm.ratebasis == 2) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Minimum boxes")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.minBoxes),
      expression: "minBoxes"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "id": "minBoxes",
      "type": "number",
      "name": "Minimum Boxes",
      "placeholder": "Enter Minimum Boxes"
    },
    domProps: {
      "value": (_vm.minBoxes)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnly($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.minBoxes = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.minboxesflag),
      expression: "minboxesflag"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Minimum Boxes Field is required")])], 1) : _vm._e()]), _c('br'), _vm._v(" "), (_vm.ratebasis == 1) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "card-header -filter_main",
    staticStyle: {
      "width": "100%",
      "height": "25px",
      "padding": "0px 0px 5px 8px"
    }
  }, [_vm._v("Applicable Weight")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Max/Min")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.applicableMaxMinList,
      "selected-option": _vm.applicableWeight.selectedMaxMin,
      "name": "MaxMin",
      "placeholder": "",
      "isDisabled": true
    },
    on: {
      "select": _vm.selectApplicableMaxMin
    }
  })], 1)], 1), _vm._v(" "), _c('label', {
    staticStyle: {
      "padding": "35px 0px 0px 0px"
    }
  }, [_vm._v("OF {")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Weight")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.ApplicableWeightList,
      "selected-option": _vm.applicableWeight.selectedWeight1,
      "name": "Weight1",
      "placeholder": "Select Weight",
      "isDisabled": false
    },
    on: {
      "select": _vm.selectApplicableWeight1
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.weightpresent),
      expression: "weightpresent"
    }],
    staticClass: "text-danger errormsg",
    staticStyle: {
      "font-size": "0.9em"
    }
  }, [_vm._v("Please select Applicable Weight")])], 1), _vm._v(" "), _c('label', {
    staticStyle: {
      "padding": "35px 0px 0px 0px"
    }
  }, [_vm._v(" OR ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "padding": "8px 0px 0px 0px"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.ApplicableWeightList2,
      "selected-option": _vm.applicableWeight.selectedWeight2,
      "name": "Weight2",
      "placeholder": "",
      "isDisabled": true
    },
    on: {
      "select": _vm.selectApplicableWeight2
    }
  })], 1)], 1), _vm._v(" "), _c('label', {
    staticStyle: {
      "padding": "35px 0px 0px 0px"
    }
  }, [_vm._v("} ")])])])]) : _vm._e(), _vm._v(" "), (_vm.ratebasis == 1) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "card-header -filter_main",
    staticStyle: {
      "width": "100%",
      "height": "25px",
      "padding": "0px 0px 5px 8px"
    }
  }, [_vm._v("Bill Weight")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "min-height": "85px"
    }
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Rounding")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.applicableWeightRoundlist,
      "selected-option": _vm.billWeight.selectedround,
      "name": "Rounding",
      "placeholder": ""
    },
    on: {
      "select": _vm.selectApplicableWeightRound
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Rounding Factor (kg) ")]), _vm._v(" "), _c('b-input-group', [_c('treeselect', {
    attrs: {
      "clearable": false,
      "multiple": false,
      "max-height": 200,
      "options": _vm.billableWeightRoundingFactorlist,
      "placeholder": "Select Rounding Factor",
      "append-to-body": true,
      "name": "rounding factor"
    },
    on: {
      "select": _vm.selectBillableWeightRoundingFactor
    },
    model: {
      value: (_vm.billWeight.selectedroundingfactor),
      callback: function($$v) {
        _vm.billWeight.selectedroundingfactor = $$v
      },
      expression: "billWeight.selectedroundingfactor"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "15px 0px 0px 0px"
    }
  }, [_vm._v(" OF ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Weight")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.billWeightList,
      "selected-option": _vm.billWeight.selectedBillWeight1,
      "name": "BillWeight1",
      "placeholder": "",
      "isDisabled": true
    },
    on: {
      "select": _vm.selectBillWeight1
    }
  })], 1)], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveWeightDimension
    }
  }, [_vm._v("Save "), _c('i', {
    staticClass: "fa fa-save"
  })])]), _vm._v("  \n    "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "-btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveAndNextWeightDimension
    }
  }, [_vm._v("Save and Next "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])])]), _vm._v(" "), _c('br')])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03f88db8","hasScoped":true}!./src/modules/masterdata/views/ratetemplate/createratetemplate/weightdimension/weightdimension.component.html
// module id = 629
// module chunks = 3